import { render, staticRenderFns } from "./HomeValues.vue?vue&type=template&id=e181a7f8&scoped=true"
import script from "./HomeValues.vue?vue&type=script&lang=js"
export * from "./HomeValues.vue?vue&type=script&lang=js"
import style0 from "./HomeValues.vue?vue&type=style&index=0&id=e181a7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e181a7f8",
  null
  
)

export default component.exports